var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgPrivateLock = function SvgPrivateLock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    viewBox: "0 0 122.88 122.88"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61.44 0A61.46 61.46 0 1118 18 61.21 61.21 0 0161.44 0zM41.2 53.72h1v-3.26a20.24 20.24 0 015.6-14 18.64 18.64 0 0127.18 0 20.24 20.24 0 015.6 14v3.26h1.05a3.14 3.14 0 013.14 3.13V87.8a3.15 3.15 0 01-3.14 3.14H41.2a3.14 3.14 0 01-3.13-3.14V56.85a3.13 3.13 0 013.13-3.13zm7 0h26.5v-3.26a14.29 14.29 0 00-3.93-9.9 12.75 12.75 0 00-18.66 0 14.25 14.25 0 00-3.93 9.9v3.26zM59 73.73l-3.3 8.54h11.48l-3-8.65a6 6 0 10-5.2.11z",
    fillRule: "evenodd"
  })));
};

export default SvgPrivateLock;